module.exports = __webpack_public_path__ + "static/media/filmm2020.ea12b89a.png";